import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';

dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);
dayjs.extend(relativeTime);
dayjs.extend(utc);

dayjs.updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: function (number: number) {
      if (number >= 13) {
        const nearestWeek = Math.round(number / 7);
        return `${nearestWeek} weeks`;
      }

      if (number >= 7) {
        return 'a week';
      }

      return `${number} days`;
    },
    w: 'a week',
    ww: '%d weeks',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years',
  },
});

/** Serialize a picked date as UTC midnight of that calendar day (timezone-safe). */
export function toDateOnly(date: Date | string | null | undefined): string | undefined {
  if (!date) return undefined;
  return dayjs(date).format('YYYY-MM-DD') + 'T00:00:00Z';
}

/** Parse a date-only backend value, reading it in UTC so the day never shifts. */
export function fromDateOnly(value: string | null | undefined) {
  return value ? dayjs.utc(value) : null;
}

/** The browser's IANA zone, sent as `?tz=` so the server buckets days the way the person sees them. */
export function localTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function utcStartOfToday() {
  return dayjs.utc().startOf('day');
}

export function daysUntilDateOnly(value: string | null | undefined) {
  const target = fromDateOnly(value);
  return target ? target.diff(utcStartOfToday(), 'day') : null;
}

export default dayjs;
